query getTemplates($limit: Int, $offset: Int, $order: JSON, $template_type: String, $group: Boolean, $title: String, $filter: String) {
    getTemplates(limit: $limit, offset: $offset, order: $order, template_type: $template_type, group: $group, title: $title, filter: $filter) 
}
